var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-link-button-dropdown',{attrs:{"items":_vm.decoratedItems,"item-key":_vm.selectKey,"has-search":"","placeholder":"Select provider","dropdown-style":{
    width: '280px',
  },"search-placeholder":"Search or add provider","data-test-id":"provider-selector"},on:{"select":_vm.handleItemSelect,"searchStringChange":_vm.handleSearchStringChange}})}
var staticRenderFns = []

export { render, staticRenderFns }